import { useUser } from '~~/stores/user';
import { RoutePermission } from './interfaces/RoutePermission';

export class RoutePermissions {
  // Private properties
  private static readonly internalValues: RoutePermission[] = [
    // #region Admin Panel Routes

    // Employers
    { path: '/admin/employers/:id', permissions: ['admin:employers:details'] },
    { path: '/admin/employers/:id/update', permissions: ['admin:employers:update'] },
    { path: '/admin/employers/create', permissions: ['admin:employers:create'] },
    { path: '/admin/employers', permissions: ['admin:employers:read'] },
    { path: '/admin/employers/manage', permissions: ['admin:employers:create'] },
    { path: '/admin/employers/manage/:id', permissions: ['admin:employers:update'] },

    // Employees
    { path: '/admin/employees/create', permissions: ['admin:employees:create'] },
    { path: '/admin/employees/employee-settings', permissions: ['admin:employees:read'] },
    { path: '/admin/employees', permissions: ['admin:employees:read'] },
    { path: '/admin/employees/:id', permissions: ['admin:employees:read'] },
    { path: '/admin/employees/:id/update', permissions: ['admin:employees:update'] },

    // Reports
    { path: '/admin/reports', permissions: ['admin:reports:read'] },

    // Profiles
    { path: '/admin/profiles/:id', permissions: ['admin:profiles:read'] },
    { path: '/admin/profiles/:id/update', permissions: ['admin:profiles:update'] },
    { path: '/admin/profiles/create', permissions: ['admin:profiles:create'] },
    { path: '/admin/profiles', permissions: ['admin:profiles:read'] },

    // Themes
    { path: '/admin/themes/:id', permissions: ['admin:themes:read'] },
    { path: '/admin/themes/:id/update', permissions: ['admin:themes:update'] },
    { path: '/admin/themes/create', permissions: ['admin:themes:create'] },
    { path: '/admin/themes', permissions: ['admin:themes:read'] },

    // Articles
    { path: '/admin/articles/create', permissions: ['admin:articles:create'] },
    { path: '/admin/articles', permissions: ['admin:articles:read'] },
    { path: '/admin/articles/:id', permissions: ['admin:articles:read'] },
    { path: '/admin/articles/:id/update-content', permissions: ['admin:articles:create'] },
    { path: '/admin/articles/:id/update', permissions: ['admin:articles:update'] },


    // Dashboard
    { path: '/admin/dashboard', permissions: ['admin:dashboard'] },


    // Service alerts
    { path: '/admin/service-alerts', permissions: ['admin:servicealert:create'] },
    { path: '/admin/service-alerts/create', permissions: ['admin:servicealert:create'] },

    // Settings
    { path: '/admin/settings', permissions: ['admin:settings'] },
    { path: '/admin/settings/export-users', permissions: ['admin:settings'] },

    // Teams
    { path: '/admin/teams/:id', permissions: ['admin:teams:read'] },
    { path: '/admin/teams/:id/update', permissions: ['admin:teams:update'] },
    { path: '/admin/teams/create', permissions: ['admin:teams:create'] },
    { path: '/admin/teams', permissions: ['admin:teams:read'] },


    // PE
    { path: '/admin/competencies', permissions: ['admin:competencies:read'] },
    { path: '/admin/competencies/create', permissions: ['admin:competencies:create'] },
    { path: '/admin/competencies/:id', permissions: ['admin:competencies:read'] },
    { path: '/admin/modules', permissions: ['admin:modules:read'] },
    { path: '/admin/modules/create', permissions: ['admin:modules:create'] },
    { path: '/admin/modules/:id', permissions: ['admin:modules:read'] },
    { path: '/admin/qualifications', permissions: ['admin:qualifications:read'] },
    { path: '/admin/certificates', permissions: ['admin:certificates:read'] },
    { path: '/admin/lamark', permissions: ['admin:exams:read'] },

    // My Employer
    { path: '/admin/my-employer', permissions: ['admin:myemployer:read'] },

    // Support
    { path: '/admin/support', permissions: null },

    // Support
    { path: '/support', permissions: null },

    // Faq
    { path: '/admin/faq', permissions: null },

    // Faq
    { path: '/faq', permissions: null },

    // #endregion

    // #region Auth routes
    // { path: '/login', permissions: null },
    { path: '/callback', permissions: null },
    { path: '/loggedout', permissions: null },
    { path: '/logout', permissions: null },
    // #endregion

    // #region User Routes
    // Articles
    { path: '/articles', permissions: ['user:articles:read'] },
    { path: '/articles/:id', permissions: ['user:articles:read'] },

    // Dashboard
    { path: '/', permissions: ['user:dashboard'] },
    { path: '/dashboard', permissions: ['user:dashboard'] },
    { path: '/article/:id', permissions: ['user:dashboard'] },

    // Profile
    { path: '/my-profile', permissions: ['user:my-profile'] },
    { path: '/my-profile/optional', permissions: ['user:my-profile'] },
    { path: '/my-profile/themes', permissions: ['user:my-profile'] },
    { path: '/my-profile/edit', permissions: ['user:my-profile'] },

    // Reports
    { path: '/rapportages', permissions: ['user:reports:read'] },

    // Templates
    { path: '/templates', permissions: null },

    // T&C's
    { path: '/terms-conditions', permissions: null },

    // User agreement
    { path: '/account-setup', permissions: null },

    // #endregion
    { path: '/test', permissions: null },

    { path: '/account-error', permissions: null },

    // Documents
    { path: '/Algemene_voorwaarden_Wft_Triple_A.pdf', permissions: null },
    { path: '/privacyverklaring WFT Triple A.pdf', permissions: null },

    // TEMP/DEV
    { path: '/v2', permissions: ['admin:employers:read'] },
    { path: '/v2/profile/:profileId/theme/:themeId', permissions: ['admin:employers:read'] },

    { path: '/403', permissions: null },
    { path: '/404', permissions: null },
    { path: '/423', permissions: null },
  ];

  // Public properties
  public static get values(): RoutePermission[] {
    return this.internalValues;
  }

  // Methods
  public static hasPermissions(routePermissions: string[]): boolean {
    const user = useUser();

    if (!user.permissions) {
      return false;
    }
    console.log(user.permissions);
    return routePermissions.every((permission) => user.permissions?.includes(permission));
  }

  public static hasPermission(permission: string): boolean {
    const user = useUser();

    if (!user.permissions) {
      return false;
    }

    return user.permissions.includes(permission);
  }
}
